<script>
    import { onMount } from "svelte";
    import Header from "../header.svelte";
    import { push } from "svelte-spa-router";
    import { api_host, user_store } from "../../stores.js";
    import { getToken, doFetch } from '../../utils/Fetching.js';
    import { toast_message } from "../../utils/toast_message.js";
    import { handle_not_subscribed } from '../../utils/format.js';
    import Swal from "sweetalert2";


    let myself = {};
    user_store.subscribe(value => {
        myself = value;
        if (myself.role !== 'landscaper') {
            push('#/Settingscompany');
        }
    });

    let connected_accounts = [];
    let is_busy = false;
    let content_title = "Settings - Payment";

    const { auth_type, auth_token, domain_code } = getToken();

    const refresh_bank = async () => {
        is_busy = true;
        const res = await doFetch(
            `${api_host}/api/landscaper/get/bank`,
            'GET',
            null,
            { Authorization: `${auth_type} ${auth_token}`, 'DomainCode': domain_code, 'Content-Type': 'application/json' }
        );
        if (res.status) {
            const { connected_accounts: _connected_accounts } = res;
            connected_accounts = _connected_accounts;
        } else {
            connected_accounts = [];
            toast_message(false, res.msg || 'Failed', 2000);
        }
        is_busy = false;
    }

    onMount(async () => {
        refresh_bank();
    });

    const connect_stripe = async (link_type) => {
        if (myself['is_subscribed'] !== undefined && !myself['is_subscribed']) {
            handle_not_subscribed(myself.is_authenticated, myself.is_domain_expired);
            return;
        }
        is_busy = true;
        const url = `${api_host}/api/landscaper/get/stripe_link/${link_type}`;
        const res = await doFetch(
            url,
            'GET',
            null,
            { Authorization: `${auth_type} ${auth_token}`, 'DomainCode': domain_code, 'Content-Type': 'application/json' }
        );
        if (res.status) {
            const { url } = res.account_link;
            window.location.href = url;
        } else {
            toast_message(false, 'Something wrong, try again later', 2000);
        }
        is_busy = false;
    }
</script>


<Header title="{content_title}" bind:is_busy={is_busy} />

<div class="contentholder">
    <div class="section">
        <div class="sectionsubtitle">Accounts with Stripe</div>

        <div class="billininginfotableholder" style='width: 100%;overflow-y: scroll;'>
            <table style="width: 100%;max-width: 1100px;min-width: 700px;">
                <tr>
                    <th>Type</th>
                    <th>Brand</th>
                    <th>Country</th>
                    <th>Currency</th>
                    <th>Number</th>
                    <th>Status</th>
                    <th>Delete</th>
                    <th></th>
                </tr>
                    {#each connected_accounts as connected_account}
                        <tr>
                            {#if connected_account.external_accounts.data[0]}
                                <td>{connected_account.external_accounts.data[0].bank_name ? 'Bank' : 'Debit Card'}</td>
                                <td>{connected_account.external_accounts.data[0].bank_name || connected_account.external_accounts.data[0].brand}</td>
                                <td>{connected_account.external_accounts.data[0].country}</td>
                                <td style='text-transform: uppercase;'>{connected_account.external_accounts.data[0].currency}</td>
                                <td>{connected_account.external_accounts.data[0].bank_name ? `${connected_account.external_accounts.data[0].routing_number} ********${connected_account.external_accounts.data[0].last4}` : `********${connected_account.external_accounts.data[0].last4}`}</td>
                            {:else}
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            {/if}
                            <td>
                                {#if connected_account.requirements.pending_verification.length || connected_account.requirements.errors.length}
                                    <div
                                        class='cc_verify tooltip'
                                        on:click={async () => { connect_stripe(connected_account['id']); }}
                                    >
                                        Inactive
                                        <span class="tooltiptext">Click here to verify account</span>
                                    </div>
                                {:else if !connected_account.payouts_enabled}
                                    <div
                                        class='cc_verify cc_pending tooltip'
                                        on:click={async () => { connect_stripe(connected_account['id']); }}
                                    >
                                        Pending
                                        <span class="tooltiptext">Payouts are disabled.</span>
                                    </div>
                                {:else if connected_account.requirements.currently_due.length || connected_account.requirements.eventually_due.length}
                                    <div
                                        class='cc_verify tooltip'
                                        on:click={async () => { connect_stripe(connected_account['id']); }}
                                    >
                                        Verification information required
                                        <span class="tooltiptext">Verification information required</span>
                                    </div>
                                {:else}
                                    Active
                                {/if}
                            </td>
                            <td>
                                <i class='fas fa-trash-alt' style='color: #ab003c;margin-left: 15px;cursor: pointer;' on:click={async () => {
                                    Swal.fire({
                                        title: "Delete this account?",
                                        text: '',
                                        buttonsStyling: true,
                                        confirmButtonClass: "button",
                                        confirmButtonText: 'Ok',
                                        cancelButtonText: "Cancel",
                                        showCancelButton: true,
                                        icon: "warning"
                                    }).then(async (e) => {
                                        if (e.isConfirmed) {
                                            const res = await doFetch(
                                                `${api_host}/api/landscaper/delete/stripe`,
                                                'POST',
                                                { account_id: connected_account['id'] },
                                                { Authorization: `${auth_type} ${auth_token}`, 'DomainCode': domain_code, 'Content-Type': 'application/json' }
                                            );
                                            if (res.status) {
                                                toast_message(true, res.msg, 2000);
                                                refresh_bank();
                                            } else {
                                                toast_message(false, 'Sorry, this account cannot be deleted.', 2000);
                                            }
                                        }
                                    });
                                }}></i>
                            </td>
                            <td>
                                <div
                                    class={`${connected_account.is_default ? 'cc_default' : 'cc_set_default_btn'}`}
                                    on:click={async () => {
                                        if (!connected_account.is_default) {
                                            const res = await doFetch(
                                                `${api_host}/api/landscaper/set/stripe/default`,
                                                'POST',
                                                { account_id: connected_account['id'] },
                                                { Authorization: `${auth_type} ${auth_token}`, 'DomainCode': domain_code, 'Content-Type': 'application/json' }
                                            );
                                            if (res.status) {
                                                toast_message(true, res.msg, 2000);
                                                refresh_bank();
                                            } else {
                                                toast_message(false, res.msg || 'Failed', 2000);
                                            }
                                        }
                                    }}
                                >
                                    {connected_account.is_default ? 'default' : 'set as default'}
                                </div>
                            </td>
                        </tr>
                    {/each}
            </table>
        </div>
        
        <div class="buttonholder">
            <button class="savebutton" on:click={() => {
                connect_stripe('new');
            }} disabled={is_busy}><i class="far fa-save"></i> Add Account</button>
        </div>
    </div>
</div>


<style>
    :global(.ff .group) {
        margin-left: 5px;
        margin-right: 5px;
    }
    :global(.rowwrap) {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
    }
    :global(.rowwrap .group) {
        min-width: 200px;
        max-width: 200px;
    }
    .contentholder {
        padding: 0px;
        width: 100%;
    }
    .buttonholder {
        margin-top: 10px;
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }
    .buttonholder button {
        max-width: 300px;
    }
    .buttonholder button.savebutton {
        color: white;
        background-color: #357a38;
    }
    .section {
        border: 1px solid #1769aa;
    }
    @media (max-device-width: 1024px), (max-width: 1023px) {
        :global(.rowwrap) {
            width: 100%;
            display: flex;
            flex-direction: column;
            padding: 0px;
            margin: 0px;
        }
        :global(.rowwrap .group) {
            width: 100%;
            min-width: 100%;
            max-width: 100%;
        }
        .contentholder {
            padding: 0px;
            width: 100%;
            max-width: 100vw;
            margin-left: auto;
            margin-right: auto;
        }
        .buttonholder {
            /* max-width: 100%; */
            width: 100%;
            display: flex;
            flex-direction: column;
        }
        .buttonholder button{
            max-width: 100%;
            width: 100%;
        }
    }
    .cc_default {
        display: inline;
        background: lightgray;
        border-radius: 5px;
        padding: 2px 5px 2px 5px;
    }
    .cc_set_default_btn {
        cursor: pointer;
        display: inline;
        background: green;
        color: white;
        border-radius: 5px;
        padding: 2px 5px 2px 5px;
        white-space: nowrap;
    }
    .cc_verify {
        cursor: pointer;
        display: inline;
        background: red;
        color: white;
        border-radius: 5px;
        padding: 2px 5px 2px 5px;
    }
    .cc_pending {
        background: #adad00;
    }
    .tooltip {
        position: relative;
        display: inline-block;
        border-bottom: 1px dotted black;
        opacity: 1;
    }
    .tooltip .tooltiptext {
        visibility: hidden;
        width: 170px;
        background-color: black;
        color: #fff;
        text-align: center;
        border-radius: 6px;
        padding: 2px 0;
        position: absolute;
        z-index: 1;
        bottom: 110%;
        left: 50%;
        font-size: 12px;
        margin-left: -60px;
    }
    .tooltip:hover .tooltiptext {
        visibility: visible;
    }
</style>
